import React from 'react'
import _ from "lodash"
import {connect} from "react-redux";

import { Grid } from '@material-ui/core'

import PortfolioExAnteV2 from "../../../../../../Trades/components/ExAnteStep/components/PortfolioExAnteV2";
import {displayErrorSnackBar} from "../../../../../../../components/SnackbarProvider/actions";
import {getErrorMessage} from "../../../../../../../utils/utils";
import ExAntePDFButton from "./ExAntePDFButton";
import InfoCard from "../DynamicStep/components/InfoCard";
import {EX_ANTE_INFO_TEXT} from "../../../../../constants";

import useStyles from "./styles";

function ExAnteStepV2(props) {

  const {
    dataService,
    questions: [
      exAnte
    ],
  } = props;

  const exAnteData = _.get(exAnte.answer, 'onboarding.buy');
  const hasExAnteData = !!exAnteData;

  React.useEffect(() => {
    if(!!exAnte.error) {
      props.dispatch(displayErrorSnackBar(getErrorMessage(exAnte.error)));
    }
  }, [exAnte.error]);

  if(exAnte.error){
    return null;
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <InfoCard
          info_text={hasExAnteData ? EX_ANTE_INFO_TEXT : <MissingExAnteWarn />}
          cardType={hasExAnteData ? undefined : 'warning' }
          isNewDesign
        />
      </Grid>
      {hasExAnteData && (
        <ExAnteSection exAnteData={exAnteData} dataService={dataService} />
      )}
    </Grid>
  )
}

export default connect()(ExAnteStepV2);

const ExAnteSection = ({dataService, exAnteData}) => {
  const classes = useStyles();

  const stepData = React.useMemo(() => {
    const productsService = dataService._getStepService('products_selection');
    const depot = productsService.getDepot(true);

    const _data = {
      name: _.get(depot, 'selected_contract_type.label'),
      custodian: _.get(depot, 'depot'),
      isPrivateInvestment: _.get(depot, 'is_private_investment'),
    }

    if (productsService.isIndividualAssetManagementProcess()) {
      _data.isIndividualAssetManagement = true;
      _data.totalAmount = _.get(exAnteData, '5.invested_amount')
    } else {
      let instruments;
      const ptf = productsService.getStepAnswer('product-selection-investment-recommendation', 'instruments_source');
      if(!!ptf) {
        instruments = [ptf]

        if(ptf.baseFondTransaction){
          instruments.push(ptf.baseFondTransaction)
        }
      } else {
        instruments = productsService.getStepAnswer('product-selection-investment-recommendation', 'instruments') || [];
      }

      function _getPaymentsPerYear(period) {
        // 1 - Monthly, 2 - Quarterly, 3 - Bimonthly, 4 - Half year, 5 - Yearly
        return _.get({'1': 12, '2': 4, '3': 6, '4': 2, '5': 1}, String(period), 0);
      }

      _data.totalAmount = 0;
      _data.oneYearSavingsPlan = 0;
      instruments.forEach(item => {
        if(item.savingsPlanAmount){
          _data.oneYearSavingsPlan += item.savingsPlanAmount * _getPaymentsPerYear(item.savingPlanData.rotation.value);
        }

        if(item.amount){
          _data.totalAmount += item.amount;
        }
      });
    }

    return _data;
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Grid container alignItems={"center"}>
          <Grid item xs>
            <div className={classes.depotType}><b>{stepData.name}</b></div>
            <div>Depotplattform: {stepData.custodian}</div>
          </Grid>
          <Grid item xs={'auto'}>
            <ExAntePDFButton dataService={dataService} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PortfolioExAnteV2
          totalValue={stepData.totalAmount}
          oneYearSavingsPlan={stepData.oneYearSavingsPlan}
          exAnteData={exAnteData}
          transactionType={'buy'}
          oneYearSavingsPlanTitle={'Sparplan'}
          isPrivateInvestment={stepData.isPrivateInvestment}
          isIndividualAssetManagement={stepData.isIndividualAssetManagement}
          defaultExpanded
        />
      </Grid>
    </>
  )
}

const MissingExAnteWarn = () => (
  <div>
    <b>Kostenberechnung noch nicht möglich</b><br/>
    Es wurde noch kein Produkt ausgewählt. Bitte fügen Sie zunächst ein Produkt hinzu – die Ex-Ante-Kosten werden
    dann automatisch berechnet. Sie können diesen Schritt überspringen; die Kostenaufstellung wird nach Hinzufügen
    eines Produktes automatisch erzeugt.
  </div>
)
